const getters = {
  getSendCharges(state) {
    return state.data;
  },
};

export default getters;
